import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    freeSpaceContainer: {
        minHeight: '15%',
        backgroundColor: Theme.primaryBackgroundColor,
        paddingHorizontal: 30,
        paddingVertical: 20
    },
    freeSpaceProgreesbar: {
        backgroundColor: Theme.primaryTextColor,
        height: 4
    },
    freeSpaceText: {
        color: Theme.primaryTextColor,
        marginTop: 10,
        fontSize: 18,
        fontFamily: Theme.regularFont
    }
};

export default StyleSheet.create(baseStyles);
